<template>
  <div class="supercontainer-MODO">
    <div class="container-general-MODO">
      <div class="MODOBannerOf-container">
        <div class="container-column-MODO">
          <div class="MODOBannerOf-text">
            <img
              alt="Logo modo"
              class="despegar-bbva MODO-logo desktop"
              src="@/assets/img/banners/oferta/MODO/logo-modo.svg"
            />
            <img
              alt="Logo modo"
              class="despegar-bbva MODO-logo mobile"
              src="@/assets/img/banners/oferta/MODO/logo-modo.svg"
            />
            <h2 class="MODOBannerOf-title">
              {{ title }}
            </h2>
            <p class="MODOBannerOf-subtitle">
              {{ subtitle }}
            </p>
          </div>
        </div>
        <div class="bbva-MODO">
          <img
            alt="Logo bbva vectorial etiqueta"
            class="bbva-MODO-desktop"
            src="@/assets/img/banners/oferta/MODO/bbva-MODO.svg"
          />
          <img
            alt="Logo bbva vectorial etiqueta mobile"
            class="bbva-MODO-mobile"
            src="@/assets/img/banners/oferta/MODO/bbva-MODO-mobile.svg"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerMODOOferta",
  props: {
    title: String,
    subtitle: String
  }
};
</script>

<style scoped>
.supercontainer-MODO {
  background-color: #d4edfc;
  margin-top: 50px;
}

.container-column-MODO {
  display: flex;
  align-items: center;
}

.bbva-MODO-mobile {
  display: none;
}

.container-general-MODO {
  min-height: 396.45px;
  max-width: 1281px;
  margin: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 40px;
  position: relative;
  overflow: hidden;
}

.MODOBannerOf-container {
  width: 100%;
  margin: auto;
}

.bbva-MODO {
  position: absolute;
  top: 10px;
  height: 100%;
  display: flex;
  right: 82.54px;
  z-index: 30;
}

.bbva-MODO img {
  max-width: 280.46px;
}

.MODO-logo.mobile {
  display: none;
}

.MODOBannerOf-title {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 36px;
  line-height: 40px;
  margin-bottom: 22px;
  margin-top: 16px;
  font-weight: 500;
}

.MODOBannerOf-subtitle {
  font-size: 20px;
  line-height: 24px;
  font-weight: 350;
  margin-top: 0px;
  margin-bottom: 0px;
}

.MODOBannerOf-text {
  max-width: 754px;
  margin: auto auto auto 107px;
  color: #121212;
}

@media (max-width: 1270px) {
  .MODOBannerOf-title {
    font-size: 30px;
    line-height: 34px;
  }

  .MODOBannerOf-text {
    max-width: 650px;
  }
}

@media (max-width: 1100px) and (min-width: 970px) {
  .MODOBannerOf-text {
    max-width: 450px;
  }
}

@media (max-width: 970px) and (min-width: 600px) {
  .MODOBannerOf-text {
    margin: auto auto auto 40px;
    max-width: 350px;
  }

  .MODOBannerOf-title {
    font-size: 28px;
    line-height: 32px;
  }
}

@media (max-width: 800px) {
  .bbva-MODO {
    right: 40px;
  }
  .bbva-MODO img {
    max-width: 200px;
  }
}

@media (max-width: 700px) {
  .bbva-MODO {
    right: 20px;
  }
  .bbva-MODO img {
    max-width: 160px;
  }
}

@media (max-width: 600px) {
  .container-general-MODO {
    min-height: 138px;
    padding: 29px 0 34px;
  }

  .supercontainer-MODO {
    min-height: 138px;
    max-height: 220px;
    margin-top: 8px;
  }

  .MODOBannerOf-title {
    font-size: 10px;
    font-weight: 500;
    line-height: 14px;
    margin: 0 0 4px;
  }

  .MODOBannerOf-subtitle {
    font-size: 8px;
    font-weight: 350;
    line-height: 12px;
  }

  .bbva-MODO {
    right: 5px;
    top: 5px;
  }

  .MODOBannerOf-text {
    margin: 0 83px 0 28px;
  }

  .bbva-MODO img.bbva-MODO-mobile {
    display: block;
    max-width: 70px;
  }

  .MODO-logo {
    width: 41px;
  }

  .bbva-MODO-desktop {
    display: none;
  }

  .MODO-logo.mobile {
    display: unset;
  }
  .MODO-logo.desktop {
    display: none;
  }
}
</style>
